import React from 'react'
//
import AxisLinear from './AxisLinear'

export default function Axis(props) {
  return <AxisLinear {...props} />
}
